import React from 'react';
import { Smartphone, BrainCircuit, HeartCrack, UserX, MessageSquareDashed } from 'lucide-react';
import { FadeIn } from './FadeIn';
const painPoints = [{
  icon: Smartphone,
  title: 'Ansiedad constante',
  desc: 'Mirar la pantalla cada 5 minutos esperando una notificación que no llega. El silencio te consume.'
}, {
  icon: BrainCircuit,
  title: 'La espiral de dudas',
  desc: 'Leer la conversación una y otra vez pensando: "¿Fui muy intensa? ¿Dije algo mal? ¿Por qué cambió de repente?"'
}, {
  icon: HeartCrack,
  title: 'Sentir que no eres suficiente',
  desc: 'Ese golpe directo a tu autoestima cuando te das cuenta de que para él fue tan fácil dejar de hablarte.'
}, {
  icon: UserX,
  title: 'El miedo al rechazo',
  desc: 'Verlo en línea y saber que está hablando con alguien más, pero no tiene tiempo para responderte a ti.'
}, {
  icon: MessageSquareDashed,
  title: 'Parálisis por análisis',
  desc: 'Escribir y borrar un mensaje 10 veces por miedo a cagarla de nuevo y alejarlo para siempre.'
}];
export function PainPoints() {
  return <section className="py-14 px-6 bg-[#161616] relative" data-id="element-195">
      <div className="max-w-5xl mx-auto" data-id="element-196">
        <FadeIn data-id="element-197">
          <div className="text-center mb-10" data-id="element-198">
            <h2 className="font-serif text-3xl md:text-5xl font-bold mb-4" data-id="element-199">
              Ese nudo en el estómago <br className="hidden md:block" data-id="element-200" />
              <span className="text-brand-rose italic" data-id="element-201">
                cuando te ignora...
              </span>
            </h2>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-202">
          {painPoints.map((point, index) => <FadeIn key={index} delay={index * 0.1} className={`bg-[#0a0a0a] border border-white/5 p-6 rounded-2xl hover:border-brand-rose/30 transition-colors ${index === 3 ? 'md:col-span-2 lg:col-span-1' : ''} ${index === 4 ? 'md:col-span-2 lg:col-span-2' : ''}`} data-id="element-203">
              <div className="w-10 h-10 bg-brand-rose/10 rounded-xl flex items-center justify-center mb-4 text-brand-rose" data-id="element-204">
                <point.icon className="w-5 h-5" data-id="element-205" />
              </div>
              <h3 className="text-lg font-bold mb-2 text-brand-cream" data-id="element-206">
                {point.title}
              </h3>
              <p className="text-brand-lightGray leading-relaxed text-sm" data-id="element-207">
                {point.desc}
              </p>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}